/**
 * @function countCheckedRow
 * @param { array } values
 * @returns { number }
 */
function countCheckedRow(values) {
	let count = 0;

	for (let i = 0; i < values.length; i++) {
		if (values[i].checked) count += 1;
	}

	return count;
}

export default countCheckedRow;
